import { render, staticRenderFns } from "./stockfocus.vue?vue&type=template&id=8039c7d8&scoped=true&"
import script from "./stockfocus.vue?vue&type=script&lang=js&"
export * from "./stockfocus.vue?vue&type=script&lang=js&"
import style0 from "./stockfocus.vue?vue&type=style&index=0&id=8039c7d8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8039c7d8",
  null
  
)

export default component.exports